import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseDataProvider } from './base.dataprovider';
import { ImageFile } from '../models/image-file.model';
import { ImageRecognitionResult } from '../models/image-recognition-result.model';
import { Const } from '../static/const';
import { ImageDetectionResponse } from '../models/image-detection.model';
import { ClassificationReport } from '../models/classification-report.model';
import { ClassificationRequest } from '../models/classification-request.model';
import { HttpService } from '../services/http.service';
// import { ClaimDetectionRequest } from '../models/claim-detection-request.model';
// import { DetectionResponse } from '../models/detection-response.model';
// import { ImageFile } from '../models/image-file.model';
// import { ImageRecognitionResult } from '../models/image-recognition-result.model';
// import { HttpService } from '../services/http.service';
// import { Const } from '../static/const';
// import { ImageDetectionResponse } from '../models/image-detection-response.model';
// import { BaseDataProvider } from './base.dataprovider';
// import { ClassificationResult } from '../models/classification-result.model';
// import { ClassificationReport } from '../models/classification-report.model';
// import { ClassificationRequest } from '../models/classification-request.model';

@Injectable({
  providedIn: 'root',
})
export class ClassificationDataProvider extends BaseDataProvider {
  constructor(private httpService: HttpService, public http: HttpClient) {
    super();
  }

  getTextOcr(file: ImageFile): Observable<ImageRecognitionResult> {
    const headers = new HttpHeaders();
    const data = {
      image_bytes: file.base64.split(',')[1],
      environment: localStorage.getItem('environment'),
    };
    const url = Const.connectionUrl + '/api/extract_text_img';

    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: ImageRecognitionResult) => {},
        (err) => {
          // this.handleHttpError(err);
          // throwError(err);
          console.log(err);
        }
      )
    );
  }

  //function to extract text from particular region in IRA
  getRegionTextOcr(file: ImageFile): Observable<ImageRecognitionResult> {
    const headers = new HttpHeaders();
    const url = Const.connectionUrl + '/api/image_extractor';

    return this.httpService.uploadFile(url, file, headers).pipe(
      tap(
        (res: any) => {},
        (err) => {
          // this.handleHttpError(err);
          // throwError(err);
          console.log(err);
        }
      )
    );
  }

  //function to extract text from particular region in EEOC
  getEEOCRegionTextOcr(file: ImageFile): Observable<ImageRecognitionResult> {
    const headers = new HttpHeaders();
    const url = Const.connectionUrl + '/api/image_extractor';

    return this.httpService.uploadFile(url, file, headers).pipe(
      tap(
        (res: any) => {},
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  //function to extract text from image in IRA
  getImageDetections(file: ImageFile): Observable<ImageDetectionResponse> {
    const headers = new HttpHeaders();

    const data = {
      image_bytes: file.base64.split(',')[1],
      environment: localStorage.getItem('environment'),
    };
    const url = Const.connectionUrl + '/api/image_segmentor';
    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: ImageDetectionResponse) => {
          res.results = res.results || [];
        },
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  //function to extract text from image in EEOC
  getEeocImageDetections(file: ImageFile): Observable<ImageDetectionResponse> {
    const headers = new HttpHeaders();

    const data = {
      image_bytes: file.base64.split(',')[1],
      environment: localStorage.getItem('environment'),
      application: 'EEOC',
    };
    const url = Const.connectionUrl + '/api/image_segmentor';
    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: ImageDetectionResponse) => {
          res.results = res.results || [];
        },
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  // getClaimDetections(
  //   claimDetectionRequest: ClaimDetectionRequest
  // ): Observable<DetectionResponse> {
  //   const headers = new HttpHeaders();
  //   return this.httpService
  //     .post(
  //       this.getApiUrl(Const.apiTextDetection),
  //       claimDetectionRequest,
  //       headers
  //     )
  //     .pipe(
  //       tap(
  //         (res: DetectionResponse) => {
  //           res.detections = res.detections || [];
  //         },
  //         (err) => {
  //           this.handleHttpError(err);
  //           throwError(err);
  //         }
  //       )
  //     );
  // }

  //get result for image/text in IRA
  getClassification(
    images: ImageFile[],
    classificationRequest: ClassificationRequest,
    textClaims: any,
    qualifiers: any,
    marketingChannels: any,
    isExcel: boolean
  ): Observable<ClassificationReport> {
    const headers = new HttpHeaders();
    const formData = new FormData();

    const imageArray: any = [];
    const resultArray: any = [];

    const docId = localStorage.getItem('docId');

    let data;
    let url;
    const coordinates = { coordinates: classificationRequest.claims };

    // if (isExcel == false) {
    //for image,pdf document result
    images.forEach((image) => {
      const img_data = image.base64.split(',')[1];
      imageArray.push(img_data);
    });

    data = {
      Image: imageArray,
      txt_ext: textClaims,
      data: coordinates,
      doc_id: docId,
      project_id: localStorage.getItem('project'),
      product_id: localStorage.getItem('product'),
      country_id: localStorage.getItem('geography'),
      countries: [localStorage.getItem('geographyName')],
      session_id: sessionStorage.getItem('sessionId'),
      product_format: localStorage.getItem('productFormat'),
      environment: localStorage.getItem('environment'),
      user_security_profile: localStorage.getItem('userRole'),
      business_group: localStorage.getItem('businessGroup'),
      user_role:localStorage.getItem('userRole'),
      eeoc_params: [
        {
          existing_qualifier: qualifiers,
          marketing_channel: marketingChannels,
          new_marketing_channel: marketingChannels,
        },
      ],
    };

    url = Const.connectionUrl + '/api/classify_img';
    // } else {
    //   //for excel document result
    //   const result = classificationRequest.claims.reduce(function (
    //     r: any,
    //     a: any
    //   ) {
    //     r[a.className.toLowerCase()] = r[a.className.toLowerCase()] || [];
    //     r[a.className.toLowerCase()].push(a.text);
    //     return r;
    //   },
    //   Object.create({}));

    //   let textData: any;
    //   const textRes =
    //     result.text.includes(undefined) || result.text.includes(null);
    //   if (textRes == true) {
    //     textData = result.text.slice(0, -1);
    //   } else {
    //     textData = result.text;
    //   }

    //   data = {
    //     text: textData,
    //     session_id: sessionStorage.getItem('sessionId'),
    //     project_id: localStorage.getItem('project'),
    //     product_id: localStorage.getItem('product'),
    //     country_id: localStorage.getItem('geography'),
    //     countries: [localStorage.getItem('geographyName')],
    //     page_no: (classificationRequest.claims[0].pageNumber + 1).toString(),
    //     product_format: localStorage.getItem('productFormat'),
    //     funcapp: 'no',
    //     environment: localStorage.getItem('environment'),
    //   };

    //   url = Const.connectionUrl + '/api/classify_text';
    // }

    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: any) => {},
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  //get result for image/text in EEOC
  getResultTableData(
    textClaims: any,
    qualifierClaims: any,
    marketingChannels: [],
    fileBase64: any
  ): Observable<ClassificationReport> {
    const headers = new HttpHeaders();

    // const textValues: any = [];
    // textClaims.map((resp) => {
    //   resp.map((value) => {
    //     textValues.push(value);
    //   });
    // });

    const qualifierValues: any = [];
    qualifierClaims.map((response) => {
      if (response != undefined) {
        response.map((result) => {
          qualifierValues.push(result);
        });
      }
    });

    const data = {
      text_ext: textClaims,
      project_id: localStorage.getItem('project'),
      product_id: localStorage.getItem('product'),
      geography_id: localStorage.getItem('geography'),
      session_id: sessionStorage.getItem('sessionId'),
      marketing_channels: marketingChannels || [],
      environment: localStorage.getItem('environment'),
      qualifier_ext: qualifierValues || [],
      user_id: localStorage.getItem('userId'),
      input_language: localStorage.getItem('language'),
      user_security_profile: localStorage.getItem('userRole'),
      project_access: JSON.parse(
        localStorage.getItem('projectAccessDetails') || ''
      ),
      business_group: localStorage.getItem('businessGroup'),
      category: localStorage.getItem('category'),
      action: 'create',
      fileBase64: fileBase64,
    };

    const url = Const.connectionUrl + '/api/get_claims_la';

    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: any) => {
          return res;
        },
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  //get result for image/text in Edit Claims flow in EEOC
  getEEOCEditClaimsClassification(): Observable<ClassificationReport> {
    const headers = new HttpHeaders();

    const data = {
      text_ext: [],
      project_id: localStorage.getItem('project'),
      product_id: localStorage.getItem('product'),
      geography_id: localStorage.getItem('geography'),
      session_id: sessionStorage.getItem('sessionId'),
      marketing_channels: [],
      environment: localStorage.getItem('environment'),
      qualifier_ext: [],
      user_id: localStorage.getItem('userId'),
      input_language: localStorage.getItem('language'),
      user_security_profile: localStorage.getItem('userRole'),
      project_access: JSON.parse(
        localStorage.getItem('projectAccessDetails') || ''
      ),
      business_group: localStorage.getItem('businessGroup'),
      category: localStorage.getItem('category'),
      action: 'update',
    };

    const url = Const.connectionUrl + '/api/get_edit_claims_las_data';

    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: any) => {
          return res;
        },
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  //get result for image/text in Edit Claims LA flow in EEOC
  getEEOCEditLAClassification(): Observable<ClassificationReport> {
    const headers = new HttpHeaders();

    const data = {
      project_id: localStorage.getItem('project'),
      product_id: localStorage.getItem('product'),
      geography_id: localStorage.getItem('geography'),
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
      user_id: localStorage.getItem('userId'),
      user_security_profile: localStorage.getItem('userRole'),
      project_access: JSON.parse(
        localStorage.getItem('projectAccessDetails') || ''
      ),
      business_group: localStorage.getItem('businessGroup'),
      category: localStorage.getItem('category'),
    };

    const url = Const.connectionUrl + '/api/get_edit_las_data';

    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: any) => {
          return res;
        },
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  //get result for excel in EEOC
  getEEOCExcelClassification(
    excelBase64,
    marketingChannels
  ): Observable<ClassificationReport> {
    const headers = new HttpHeaders();
    const data = {
      img: excelBase64.split(',')[1],
      marketing_channels: marketingChannels,
      project_id: localStorage.getItem('project'),
      product_id: localStorage.getItem('product'),
      geography_id: localStorage.getItem('geography'),
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
      user_id: localStorage.getItem('userId'),
      user_security_profile: localStorage.getItem('userRole'),
      project_access: JSON.parse(
        localStorage.getItem('projectAccessDetails') || ''
      ),
      input_language: localStorage.getItem('language'),
      business_group: localStorage.getItem('businessGroup'),
      category: localStorage.getItem('category'),
      action: 'create',
    };

    const url = Const.connectionUrl + '/api/eeoc_process_excel';

    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: any) => {
          return res;
        },
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  //get risk result for image/text in EEOC
  getEeocRiskClassification(
    images: ImageFile[],
    classificationRequest: ClassificationRequest,
    textClaims: any,
    isExcel: boolean,
    textValues: any,
    qualifiers: any,
    oldMarketingChannels: any,
    newMarketingChannels: any,
    uploadId: any,
    claimOrders: any,
    lifeCycle: any,
    lifeCycle_UI: any,
    relatedTranslations: any,
    qualifierTranslations: any,
    backTranslations: any,
    textExist: any,
    document: any,
    currentPage: any
  ): Observable<ClassificationReport> {
    const headers = new HttpHeaders();
    const formData = new FormData();

    const imageArray: any = [];
    const resultArray: any = [];

    const docId = localStorage.getItem('docId');

    let data;
    let url;
    const coordinates = { coordinates: classificationRequest.claims };

    if (isExcel == false) {
      //for image,pdf document result
      images.forEach((image) => {
        const img_data = image.base64.split(',')[1];
        imageArray.push(img_data);
      });

      if (Object.keys(document).length > 0) {
        document.base64Data = '';
      }

      const fileBase64 = [
        {
          document: document,
          currentPage: currentPage,
          coordinates: coordinates,
        },
      ];
      data = {
        application: 'EEOC',
        Image: fileBase64,
        txt_ext: [textValues],
        data: coordinates,
        doc_id: uploadId,
        eeoc_params: [
          {
            selected_translated_text: relatedTranslations,
            selected_translated_qualifier_text: qualifierTranslations,
            selected_back_translated_text: backTranslations,
            text_lifecycles: lifeCycle,
            text_lifecycles_UI: lifeCycle_UI,
            text_exits: textExist,
            qualifiers: qualifiers,
             existing_qualifier: qualifiers,
            marketing_channel: oldMarketingChannels,
            new_marketing_channel: newMarketingChannels,
            claimOrder: claimOrders,
          },
        ],
        project_id: localStorage.getItem('project'),
        product_id: localStorage.getItem('product'),
        country_id: localStorage.getItem('geography'),
        countries: [localStorage.getItem('geographyName')],
        session_id: sessionStorage.getItem('sessionId'),
        product_format: localStorage.getItem('productFormat'),
        environment: localStorage.getItem('environment'),
        user_id: localStorage.getItem('userId'),
        user_security_profile: localStorage.getItem('userRole'),
        business_group: localStorage.getItem('businessGroup'),
        user_role:localStorage.getItem('userRole'),
      };

      url = Const.connectionUrl + '/api/classify_img';
    }
    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: any) => {},
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  //get risk result for image/text in Edit risk classification for Edit Claims
  getEeocEditLARiskClassification(
    images: ImageFile[],
    classificationRequest: ClassificationRequest,
    textClaims: any,
    isExcel: boolean,
    textValues: any,
    qualifiers: any,
    oldMarketingChannels: any,
    newMarketingChannels: any,
    uploadId: any,
    claimOrders: any,
    lifeCycle: any,
    lifeCycle_UI: any,
    relatedTranslations: any,
    qualifierTranslations: any,
    backTranslations: any,
    textExist: any,
    language: any,
    projectExists: any,
    statementLanguages: any,
    translateLanguages: any,
    claimID: any,
    relatedID: any,
    statementID: any,
    updatedStatus: any,
     masterExists:any,
    document: any,
    currentPage: any
  ): Observable<ClassificationReport> {
    const headers = new HttpHeaders();
    const formData = new FormData();

    const imageArray: any = [];
    const resultArray: any = [];

    const docId = localStorage.getItem('docId');

    let data;
    let url;
    const coordinates = { coordinates: classificationRequest.claims };

    if (isExcel == false) {
      //for image,pdf document result
      images.forEach((image) => {
        const img_data = image.base64.split(',')[1];
        imageArray.push(img_data);
      });

      if (Object.keys(document).length > 0) {
        document.base64Data = '';
      }
      const fileBase64 = [{ coordinates: coordinates,document: document, currentPage: currentPage }];
      data = {
        application: 'EEOC',
        Image: fileBase64,
        txt_ext: [textValues],
        data: coordinates,
        doc_id: uploadId,
        eeoc_params: [
          {
            related_translations: relatedTranslations,
            qualifier_translations: qualifierTranslations,
            back_translations: backTranslations,
            text_lifecycles: lifeCycle,
            text_lifecycles_UI: lifeCycle_UI,
            text_exits: textExist,
            qualifiers: qualifiers,
            existing_qualifier: qualifiers,
            existing_marketing_channel: oldMarketingChannels,
            marketing_channel: newMarketingChannels,
            new_marketing_channel: newMarketingChannels,
            claim_order: claimOrders,
            project_exists: projectExists,
             project_exist: projectExists,
            master_exist:masterExists,
            statement_languages: language,
            translate_languages: translateLanguages,
            claim_ids: claimID,
            related_statement_ids: relatedID,
            statement_ids: statementID,
            isUpdated: updatedStatus,
          },
        ],
        project_id: localStorage.getItem('project'),
        product_id: localStorage.getItem('product'),
        country_id: localStorage.getItem('geography'),
        countries: [localStorage.getItem('geographyName')],
        session_id: sessionStorage.getItem('sessionId'),
        product_format: localStorage.getItem('productFormat'),
        environment: localStorage.getItem('environment'),
        user_id: localStorage.getItem('userId'),
        user_security_profile: localStorage.getItem('userRole'),
        business_group: localStorage.getItem('businessGroup'),
        user_role:localStorage.getItem('userRole'),
      };

      url = Const.connectionUrl + '/api/classify_img';
    }
    return this.httpService.uploadFile(url, data, headers).pipe(
      tap(
        (res: any) => {},
        (err) => {
          // this.handleHttpError(err);
          throwError(err);
        }
      )
    );
  }

  uploadReport(classificationReport: ClassificationReport): Observable<void> {
    const headers = new HttpHeaders();

    classificationReport.text = undefined;

    classificationReport.results.forEach((result) => {});
    return this.httpService
      .post(
        this.getApiUrl(Const.apiUploadReport),
        classificationReport,
        headers,
        true
      )
      .pipe(
        tap(
          (res: any) => {},
          (err) => {
            // this.handleHttpError(err);
            throwError(err);
          }
        )
      );
  }

  getMarketingChannels() {
    const data = {
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
    };
    const url = Const.connectionUrl + '/api/marketing_channels';
    return this.http.post(url, data);
  }
}
